angular.module('jv.services', ['jv.Common.Jobvite.Urls'])
    .service('application',['$http', '$jobviteUrls', function($http, $jobviteUrls) {
        var applicationURL = '../action/app';
        var videoURL = $jobviteUrls.video + '/action/user/video';
        this.getList = function(page, callback) {
            $http.get(applicationURL + '/list/' + page).then(callback);
        };

        this.getDetails = function(id) {
            return new Promise(function(resolve, reject) {
                $http.get(applicationURL + '/' + id).then(resolve, reject);
            });
        };

        this.getNativeEsignDocument = function(id, type) {
            return new Promise(function(resolve, reject) {
                    $http.get(applicationURL + '/' + id + '/native-esign/document.pdf?type='+type).then(resolve, reject);
             });
        };

        this.getNativeEsignDocumentURL = function(id, type) {
            return applicationURL + '/' + id + '/native-esign/document.pdf?type='+type;
        };

        this.getJobDetails = function(id, callback, fail) {
            $http.get(applicationURL + '/' + id + '/job').then(callback, fail);
        };

        this.saveNativeEsignConsent = function(id, callback, fail) {
            $http.post(applicationURL + '/' + id + '/native-esign/consent').then(callback, fail);
        };

        this.saveSignature = function(data, callback, fail) {
            $http({
                url: `${applicationURL}/${data.appId}/native-esign/signature`,
                method: 'POST',
                data: data.payload,
                headers: {
                    // eslint-disable-next-line no-undefined
                    'Content-Type': undefined
                }
            }).then(callback, fail);
        };

        this.sendMessage = function(data, callback, fail) {
            $http({
                url: applicationURL + '/' + data.appId + '/message',
                method: 'POST',
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                data: $.param({
                    subject: data.subject,
                    message: data.content
                })
            }).then(callback, fail);

        };

        /*This is a temp call to hide the video tab if the jobseeker has no video interviews
         * Avoiding injecting the video service since we only need this call from it */
        this.getVideoList = function(callback, fail) {
            $http({
                url: videoURL + '/videoInterviewsLink',
                method: 'GET'
            }).then(callback, fail);
        };

        this.getOnboardingInProcess = function() {
            return $http({
                url: applicationURL + '/onboarding',
                method: 'GET'
            }).then(function(res) {
                if (res.data && res.data.msgInfo === 200) {
                    return true;
                }
                return false;
            });
        };

        this.toggleStatus = function(id, cId, statusFlag, callback, fail) {
            return $http({
                url: applicationURL + '/' + id + '/' + cId + '/toggleStatus/' + statusFlag,
                method: 'POST'
            }).then(callback, fail);
        };
    }]);
